module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "structure-bnxt1",
    attrs: {
      "id": "calibre_pb_32"
    }
  }, [_c('span', {
    staticClass: "bold1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Clean Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("1.")]), _vm._v("Avocados")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("2.")]), _c('span', [_vm._v("Pineapples")])]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("3.")]), _vm._v("Frozen "), _c('span', [_vm._v("sweet")]), _c('span'), _c('span', [_vm._v("peas")])]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("4.")]), _vm._v("Onions")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("5.")]), _vm._v("Papayas")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("6.")]), _vm._v("Eggplants")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("7.")]), _vm._v("Asparagus")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("8.")]), _vm._v("Kiwis")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("9.")]), _vm._v("Mangos")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("10.")]), _vm._v("Cabbages")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("11.")]), _vm._v("C"), _c('span', [_vm._v("auliflower")])]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("12.")]), _vm._v("C"), _c('span', [_vm._v("antaloupes")])]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("13.")]), _vm._v("Broccoli")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("14.")]), _vm._v("Mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers1",
    attrs: {
      "id": "calibre_pb_33"
    }
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("15.")]), _vm._v("Honey"), _c('span', [_vm._v("dew")]), _c('span'), _c('span', [_vm._v("melons")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-304dbcf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_018.vue
// module id = 111
// module chunks = 0